import { render, staticRenderFns } from "./VenueGeneral.vue?vue&type=template&id=dd7b93f8&scoped=true&"
import script from "./VenueGeneral.vue?vue&type=script&lang=js&"
export * from "./VenueGeneral.vue?vue&type=script&lang=js&"
import style0 from "./VenueGeneral.vue?vue&type=style&index=0&id=dd7b93f8&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dd7b93f8",
  null
  
)

export default component.exports